module.exports = __webpack_public_path__ + "img/SE44079.a4a30939.png";